import {Component, Inject, Input} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../../security/jwtUtil.service";
import { getResourceType } from '../../../../../infra/ngrsUtil';

@Component({
    "selector": "prm-offer-details-tile",
    templateUrl: 'components/search/fullView/ngrs/getItRequest/offerDetailsTile/offerDetailsTile.html'
})

export class PrmOfferDetailsTile{

    @Input() bestoffer:Object;
    @Input() private isdigitaloffer: boolean;
    @Input() item:Object;

    constructor (){       
    }

    ngOnInit(){
    }

    public getOfferLoanPeriod(){
        return this.bestoffer.loanPeriod;
    }

    public getOfferSupplyTime(){
        return this.bestoffer.supplyTime;
    }

    public isUnavailableResource(){
        return this.bestoffer.unavailableResource;
    }

    public isDigitalOffer(){
        return this.isdigitaloffer;
    }

    public getResourceType(){
        return getResourceType(this.item);
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/offerDetailsTile/offerDetailsTile.directive.ts